export const TranslatedTextKey = {
    CANNOT_GET_USER_INFO : 'mcfLoginShell.login.cannotGetUserInformation',
    INVALID_USERNAME_OR_PASSWORD : 'mcfLoginShell.login.invalidUsernameOrPassword',
    UNAUTHORIZED_ACCESS : "mcfLoginShell.login.unauthorizedAccess",
    AN_ERROR_OCURRED : "mcfLoginShell.login.anErrorOccurred",
    PASSWORD: "mcfLoginShell.login.password",
    EMAIL_ADDRESS: "mcfLoginShell.login.emailAddress",
    LOG_IN: "mcfLoginShell.login.logIn",
    USER_NAME_REQUIRED: "mcfLoginShell.login.usernameIsRequired",
    WELLCOME_TITTLE: "mcfLoginShell.login.welcomeArgosOne",
    EMAIL_REQUIRED:"mcfLoginShell.login.emailIsRequired",
    EMAIL_INVALID:"mcfLoginShell.login.emailInputInvalid",
    PASSWORD_REQUIRED:"mcfLoginShell.login.passwordIsRequired",
    SIGN_IN:"mcfLoginShell.login.signIn",
    COUNTRY_TITLE:"mcfLoginShell.login.countryTitle",
    FORGOT_PASSWORD:"mcfLoginShell.login.forgotPassword",
    ERROR_MESSAGE500:"mcfLoginShell.errorMessages.errorMessage500",
    B2C_LOGIN_ERROR:"mcfLoginShell.errorMessages.b2cLoginError",
    CAPTCHA_VALIDATION_ERROR:"mcfLoginShell.errorMessages.captchaValidationError",
    LOG_IN_GOOGLE: "mcfLoginShell.login.loginGoogle",
    LOG_IN_MICROSOFT: "mcfLoginShell.login.loginMicrosoft",
    LOG_IN_MICROSOFTMT: "mcfLoginShell.login.loginMicrosoftMT",

}